/**
 * Profile Dropdown Functionality
 */

(function() {
  'use strict';

  const profileTrigger = document.querySelector('.c-profile-dropdown__trigger');
  const profileMenu = document.querySelector('.c-profile-dropdown__menu');

  if (!profileTrigger || !profileMenu) return;

  // Toggle dropdown
  profileTrigger.addEventListener('click', function(e) {
    e.stopPropagation();
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });

  // Close on click outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.c-profile-dropdown')) {
      closeDropdown();
    }
  });

  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeDropdown();
    }
  });

  function openDropdown() {
    profileTrigger.setAttribute('aria-expanded', 'true');
    profileMenu.style.display = 'block';
  }

  function closeDropdown() {
    profileTrigger.setAttribute('aria-expanded', 'false');
    profileMenu.style.display = 'none';
  }
})();
